<div id="dashboard" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center sm:w-auto">
      <div class="flex justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Apply for Additional Home</div>
      <div class="flex justify-center px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl mt-2">Search for an additional home.</div>
    </div>
  </div>
  <div class="sm:w-auto flex justify-center border-0">

    <form #additionalForm="ngForm" (ngSubmit)="onSubmit()" class="w-full">

      <mat-form-field class="w-full my-2">
        <input type="text"
               placeholder="Address"
               aria-label="Number"
               matInput
               [formControl]="myControl"
               [matAutocomplete]="auto" required>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)='onSelect($event.option.value)'>
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <mat-error>
          Please select a home.
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="!ShowNoApplicantMsg && allCoApplicants.length > 0" class="w-full my-2">
        <mat-chip-list #chipList>
          <mat-chip
            *ngFor="let coApplicant of coApplicants"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(coApplicant)">
            {{coApplicant}}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="Apply with"
            #coApplicantInput
            [formControl]="coApplicantCtrl"
            [matAutocomplete]="autoCoApplicant"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-list>
        <mat-autocomplete #autoCoApplicant="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let coApplicant of filteredCoApplicants | async" [value]="coApplicant">
            {{coApplicant}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <div class="w-full mb-4" *ngIf="ShowNoApplicantMsg">There are no saved applicants for your profile.  Don't worry, you will be able to add them later in the process.</div>

      <div class="form-group bottom">
        <div class="row">
          <div class="col-md-12 text-right">
            <button mat-flat-button type="submit" color="primary" class=" sm:text-base w-full" [disabled]="!selectedProperty">APPLY &amp; PAY</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
